export default __webpack_public_path__ + "static/media/qr_appstore_okara.96e6e2ff.svg";